export default "__VITE_ASSET__CCWAbTKG__"